module.exports = ".work.tizo {\n  margin-top: 80px; }\n  @media (max-width: 767px) {\n    .work.tizo {\n      margin-top: 50px; } }\n  .work.tizo .img-container img {\n    width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/work-tizo/work-tizo.component.scss
// module id = ./src/app/work-tizo/work-tizo.component.scss
// module chunks = main